$('#user-post-options a').on('click', function() {
  $('#user-post-options a').removeClass('active-selection ').addClass('passive-selection');
  $(this).removeClass('passive-selection');
  $(this).addClass('active-selection');
})